import React from 'react';

export const BetHistory = React.lazy(() => import('./BetHistory'));
